import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M2 5c0-.552.471-1 1.053-1h17.894C21.53 4 22 4.448 22 5v14c0 .552-.471 1-1.053 1H3.053C2.47 20 2 19.552 2 19z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M7 9c.436 0 .79-.336.79-.75S7.435 7.5 7 7.5s-.79.336-.79.75S6.565 9 7 9"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "nonzero",
    d: "m7.263 12 2.632 2 3.158-3.5L22 17v2c0 .552-.471 1-1.053 1H3.053C2.47 20 2 19.552 2 19v-2z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }